import styled from 'react-emotion'
import { ShadowBox, colors } from '../../styles'

export const ProductContainer = styled(ShadowBox)`  
  display: flex;
  padding: 0;
  margin-top: 20px;  
  background-color: ${colors.tui_white};
  @media (max-width: 992px) {
    display: block;
  }
`

export const ContentContainer = styled('div')`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 15px;
  >div:not(:last-child) {
    flex-grow: 1;
  }
  @media (max-width: 992px) {
    >div:first-child {
      margin-bottom: 10px;
    }
  }
`

export const ContentContainerTop = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

export const ContentContainerCenter = styled('div')`
  flex-grow: 10;
`

export const ButtonRow = styled('div')`
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  align-items: flex-end;
  @media (max-width: 992px) {
    flex-direction: column;
    text-align: center;
    align-items: center;
  }
`

export const InviteUser = styled('div')`
  border-top: 1px solid ${colors.tui_border};
  padding: 15px 0;
  display: flex;
  align-items: center;
  >div {
    padding: 0 5px;
  }
  svg {
    color: ${colors.tui_link_blue};
    margin-right: 10px;
  }
  .form-group {
    margin-bottom: 0;
  }
  >:last-child {
    margin-left: auto;
  }
  h4 {
    text-transform: uppercase;
    margin-bottom: 0;
  }
  input {
    width: 300px;
  }
  .loader-container {
    padding: 0;
    img {
      height: 24px;
    }
  }
  @media (max-width: 992px) {
    input {
      width: 100%;
    }
    >:last-child {
      flex-grow: 1;
      text-align: right;
      padding-left: 10px;
      padding-right: 10px;
    }
    svg {
      margin-right: 0;
    }
  }
`